export default {
  title: 'Team',
  tooltip: 'Click here to meet our team',
  noResults: 'No results',
};
